import classNames from "classnames";
import IDream from "motw_core/Entity/IDream";
import { hashTagsService } from "motw_core/Services/HashTagsService";
import { StyleClass } from "source/app/presentation/Shared/Styles/CSS";
import { pillButtonStyleClass } from "source/app/presentation/Shared/Styles/PillButtonStyle";
import { IDropTargetResult } from "source/app/services/Shared/Hooks/useDropTarget";
import { IsDreamHashTagActive } from "../Helpers/IsDreamHashTagActive";

export function GetHashTagClassNames(
    dropTargetResult: IDropTargetResult<IDream>,
    hashTag: string
) {
    const isThisHashTagActive = IsDreamHashTagActive(hashTag);

    const dreamBeingDragged = dropTargetResult.draggedObject;
    const isDreamBeingDragged = dreamBeingDragged !== null;

    const canRemoveHashTag =
        isDreamBeingDragged &&
        hashTagsService.DoesDreamHaveHashTag(dreamBeingDragged, hashTag);

    const canAddHashTag =
        isDreamBeingDragged &&
        !hashTagsService.DoesDreamHaveHashTag(dreamBeingDragged, hashTag);

    const result = classNames(pillButtonStyleClass, mainStyleClass, {
        [activeStyleClass]: isThisHashTagActive,
        [energyHashTagStyleClass]: hashTagsService.IsEnergyHashTag(hashTag),
        [problemHashTagStyleClass]: hashTagsService.IsProblemHashTag(hashTag),
        [campaignHashTagStyleClass]: hashTagsService.IsCampaignHashTag(hashTag),
        [removeHashTagStyleClass]: canRemoveHashTag,
        [addHashTagStyleClass]: canAddHashTag,
        [hoverStyleClass]: dropTargetResult.isOver,
    });

    return result;
}

const mainStyleClass = StyleClass(`hashTagLink`, {
    margin: `0px 3px`,
});

const activeStyleClass = StyleClass(`hashTagLink_active`, {
    background: `black`,
    color: `white`,
    border: `1px dotted #ffb84e`,
});

const energyHashTagStyleClass = StyleClass(`energyHashTag`, {
    color: `#fff187 !important`,
});

const problemHashTagStyleClass = StyleClass(`problemHashTag`, {
    color: `#ff9efe !important`,
});

const campaignHashTagStyleClass = StyleClass(`campaignHashTag`, {
    color: `#dad0ff !important`,
});

const removeHashTagStyleClass = StyleClass(`hashTagCanBeRemoved`, {
    border: `1px solid coral`,
});

const addHashTagStyleClass = StyleClass(`hashTagCanBeAdded`, {
    border: `1px solid yellowgreen`,
});

const hoverStyleClass = StyleClass(`hashTagHoverOver`, {
    fontWeight: `bold`,
});
